import * as React from 'react'

// context
import { useStreamContext } from '../../../context';

// hooks
import useStreamActions from '../../../hooks.stream/useStreamActions'

// rsuite
import { Button, Divider } from 'rsuite';

// components
import JsonView from '../../../components/JsonView';


export default function DrawerContainer() {

  // context
  const streamContext = useStreamContext()

  // hooks
  const streamActions = useStreamActions()

  return (
    <>

      <div>

        <h6>Current config</h6>
        <JsonView data={streamContext.state} />

        <Divider />

        <h6>Commands history</h6>
        <JsonView data={streamContext.commandsList} />

        <Divider />

        {/* <Button
          onClick={() => {
            streamActions.emitUi({ test: 'demo' })
          }}>
          Send data
        </Button> */}

        <Button
          onClick={() => {
            streamActions.resetResolution()
          }}>
          Reset resolution
        </Button>
      </div>
    </>
  )
}